import { vservice } from '@niknevis/vue-modules'
import { AdminProfitRoute } from '@/modules/profit/routes/admin-profit.route'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { ProfitRequest } from '@/modules/profit/models/profit-request.model'

@vservice()
export class AdminProfitService {
  constructor(
    private readonly routes: AdminProfitRoute
  ) {
  }

  storeProfit(data: ProfitRequest) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }
}
